var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.welcome.apply(null, arguments)}}},[_c('v-list-item-title',[_vm._v("Welcome Email")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }